var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullwidth",class:{'widewidth':_vm.b.max}},[_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }